<template>
  <UiBaseIcon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    class="icon"
  >
    <path
      d="M10 2C5.584 2 2 5.584 2 10C2 14.416 5.584 18 10 18C14.416 18 18 14.416 18 10C18 5.584 14.416 2 10 2ZM10 16.4C6.472 16.4 3.6 13.528 3.6 10C3.6 6.472 6.472 3.6 10 3.6C13.528 3.6 16.4 6.472 16.4 10C16.4 13.528 13.528 16.4 10 16.4ZM5.6 14.4L11.608 11.608L14.4 5.6L8.392 8.392L5.6 14.4ZM10 9.12C10.488 9.12 10.88 9.512 10.88 10C10.88 10.488 10.488 10.88 10 10.88C9.512 10.88 9.12 10.488 9.12 10C9.12 9.512 9.512 9.12 10 9.12Z"
    />
  </UiBaseIcon>
</template>

<script setup lang="ts">
  import { UiBaseIcon } from '@experience/core-base-icon-ui';
</script>
